import Swiper from 'swiper/bundle';


const ftHeroCarousel = new Swiper ('.js-ft-Hero__carousel', {
  // デフォルトの設定
  slidesPerView: 1,
  spaceBetween: 16,
  pagination: {
    el: ".ft-Hero__carouselPagination",
    clickable: true,
  },

  // Navigation arrows
  navigation: {
    nextEl: ".ft-Hero__carouselNext",
    prevEl: ".ft-Hero__carouselPrev",
  },

  breakpoints: {

    // when window width is <= 640px
    640: {
      slidesPerView: 2,
      spaceBetween: 30,
    },
    // when window width is <= 640px
    834: {
      slidesPerView: 3,
      spaceBetween: 30,
    },

  }
});


const ftNewsItems = new Swiper ('.js-ft-News__items', {
  // デフォルトの設定
  slidesPerView: 2,
  spaceBetween: 16,
  // Navigation arrows
  navigation: {
    nextEl: ".ft-News__next",
    prevEl: ".ft-News__prev",
  },

  breakpoints: {

    1001: {
      slidesPerView: 3,
      spaceBetween: 40,
    },
  }

});

const ftStyleItems = new Swiper ('.js-ft-Style__items', {
  // デフォルトの設定
  slidesPerView: 1,
  spaceBetween: 16,
  loop: true,
  centeredSlides: true,

  pagination: {
    el: ".ft-Style__pagination",
    clickable: true,
  },

  // Navigation arrows
  navigation: {
    nextEl: ".ft-Style__next",
    prevEl: ".ft-Style__prev",
  },

  breakpoints: {

    // when window width is <= 640px
    668: {
      slidesPerView: 2,
      spaceBetween: 16,
    },

    1000: {
      slidesPerView: 3,
      spaceBetween: 40,
    },
  }

});

const mdGeneralSlide = new Swiper ('.js-md-GeneralSlider', {
  // デフォルトの設定
  slidesPerView: 1.2,
  loop: true,
  centeredSlides: true,
  spaceBetween: 16,

  navigation: {
    nextEl: ".md-GeneralSlider__next",
    prevEl: ".md-GeneralSlider__prev",
  },

  breakpoints: {

    // when window width is <= 640px
    668: {
      slidesPerView: 1.4,
      spaceBetween: 40,
    },

    821: {
      slidesPerView: 2.4,
      spaceBetween: 80,
    },
  }
});

const mdGeneralSlide2 = new Swiper ('.js-md-GeneralSlider2', {
  // デフォルトの設定
  slidesPerView: 1.2,
  loop: true,
  centeredSlides: true,
  spaceBetween: 16,

  navigation: {
    nextEl: ".md-GeneralSlider2__next",
    prevEl: ".md-GeneralSlider2__prev",
  },
  breakpoints: {

    // when window width is <= 640px
    668: {
      slidesPerView: 1.4,
      spaceBetween: 40,
    },

    821: {
      slidesPerView: 2.4,
      spaceBetween: 80,
    },
  }

});

const mdLinkList = new Swiper ('.js-md-LinkList__items', {
  // デフォルトの設定
  slidesPerView: 2,
  loop: true,
  spaceBetween: 16,

  navigation: {
    nextEl: ".md-LinkList__next",
    prevEl: ".md-LinkList__prev",
  },
  breakpoints: {

    // when window width is <= 640px
    668: {
      slidesPerView: 3,
    },

    1000: {
      slidesPerView: 4,
      spaceBetween: 32,
    }
  }

});

